var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scout-tab-panel',{attrs:{"is-active":_vm.isActive,"title":"送信候補","name":"review","link":_vm.link,"data-test":"panel-review","tooltip":"貴社がスカウトやいいねの送信を検討している会員を一時保存することができます。"}})}
var staticRenderFns = []

export { render, staticRenderFns }